import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { HttpParams } from '@angular/common/http';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';
import { Tc, EnumSiNoTodos } from 'src/app/components/core/_infrastructure/types/common';
import { AccionesPerfilTipoEstadoExService } from './accionesperfiltipoestadoEx.service';
import { EnumIdsTcTipoModulo } from '../../../_importacion/solicitudes/types/enum';
import {
    WAccionesPerfilTipoEstadoExItemResultsViewModel,
    WAccionesPerfilTipoEstadoExViewModel,
    FilterSearchingWAccionesPerfilTipoEstadoExViewModel,
} from './accionesperfiltipoestadoEx.types';
import { EnumIdsTcTipoSolicitudEx } from '../../../_exportacion/solicitudes/types/enum';
import { SubTipoSolicitudExViewModel } from '../../../_exportacion/solicitudes/datosbasicos/datosbasicosEx.types';

@Component({
    selector: 'app-accionesperfiltipoestadoex-list',
    templateUrl: './accionesperfiltipoestadoEx-list.component.html',
})
export class AccionesPerfilTipoEstadoExListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultAccionesPerfilTipoEstadoEx: WAccionesPerfilTipoEstadoExItemResultsViewModel;
    cols: any[];

    listAccionesEx: Tc[];
    listPerfil: Tc[];
    listEstadoEx: Tc[];
    listTipoEx: Tc[];
    listSubTipoSolicitudEx: SubTipoSolicitudExViewModel[];
    visibilitySpinner = false;

    idSubTipo: number | null;

    isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private accionesPerfilTipoEstadoExService: AccionesPerfilTipoEstadoExService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultAccionesPerfilTipoEstadoEx = new WAccionesPerfilTipoEstadoExItemResultsViewModel();
    }

    ngOnInit(): void {
        this.globalService.getAccionesByModulo(EnumIdsTcTipoModulo.ID_EXPORTACION).subscribe(res => {
            this.listAccionesEx = res;
        });
        this.globalService.getPerfilesUsuario().subscribe(res => {
            this.listPerfil = res;
        });
        this.globalService.getEstadoSolicitudExpor().subscribe(res => {
            this.listEstadoEx = res;
        });
        this.globalService.getTipoSolicitudExpor().subscribe(res => {
            this.listTipoEx = res;
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Modulo', header: 'Módulo' },
            { field: 'Accion', header: 'Acción' },
            { field: 'Perfil', header: 'Perfil' },
            { field: 'EstadoSolicitud', header: 'Estado Solicitud' },
            { field: 'TipoSolicitud', header: 'Tipo Solicitud' },
            { field: 'SubTipoSolicitud', header: 'Subtipo Solicitud' },
            { field: 'Edicion', header: 'Edición' },
        ];

        this.form = this.fb.group({
            IdAccion: null,
            IdPerfil: null,
            IdTipo: null,
            IdSubTipo: null,
            IdEstado: null,
            Accion: '',
            Edicion: EnumSiNoTodos.TODOS,
        });

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack(): void {
        if (this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdTipo === EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS) {
            this.globalService.getSubTipoSolicitudExpor().subscribe(res => {
                this.listSubTipoSolicitudEx = res.filter(s => s.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS);
            });
        } else if (this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdTipo === EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION) {
            this.globalService.getSubTipoSolicitudExpor().subscribe(res => {
                this.listSubTipoSolicitudEx = res.filter(s => s.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION);
            });
        } else {
            this.listSubTipoSolicitudEx = [];
        }

        if (
            this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdPerfil != null ||
            this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdAccion != null ||
            this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdTipo != null ||
            this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdSubTipo != null ||
            this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdEstado != null ||
            this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.Edicion != EnumSiNoTodos.TODOS ||
            this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.Accion != ''
        ) {
            this.form.patchValue({
                IdPerfil: this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdPerfil,
                IdAccion: this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdAccion,
                IdTipo: this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdTipo,
                IdSubTipo: this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdSubTipo,
                IdEstado: this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdEstado,
                Edicion: this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.Edicion,
                Accion: this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.Accion,
            });

            this.idSubTipo = this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdSubTipo;

            this.onSearchButton();
        }
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.search(0);

        this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdPerfil = this.form.value.IdPerfil;
        this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdAccion = this.form.value.IdAccion;
        this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdEstado = this.form.value.IdEstado;
        this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdTipo = this.form.value.IdTipo;
        this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.IdSubTipo = this.form.value.IdSubTipo;
        this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.Accion = this.form.value.Accion;
        this.accionesPerfilTipoEstadoExService.currentFilterAccionesPerfilTipoEstadoEx.Edicion = this.form.value.Edicion;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    private search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        if (this.idSubTipo != 0 && this.form.value.IdSubTipo == null) {
            this.form.value.IdSubTipo = this.idSubTipo;
        }

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('IdPerfil', this.form.value.IdPerfil);
        params = params.append('IdAccion', this.form.value.IdAccion);
        params = params.append('IdEstado', this.form.value.IdEstado);
        params = params.append('IdTipo', this.form.value.IdTipo);
        params = params.append('IdSubTipo', this.form.value.IdSubTipo);
        params = params.append('Accion', this.form.value.Accion);
        params = params.append('Edicion', this.form.value.Edicion);

        this.form.patchValue({
            IdsubTipo: this.idSubTipo,
        });

        this.loading = true;
        this.accionesPerfilTipoEstadoExService.getAccionesPerfilTipoEstadoPagedByFilter(params).subscribe(result => {
            this.resultAccionesPerfilTipoEstadoEx = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            IdAccion: null,
            IdPerfil: null,
            IdTipo: null,
            IdSubTipo: null,
            IdEstado: null,
            Accion: '',
            Edicion: EnumSiNoTodos.TODOS,
        });
        this.searchingButton = false;
        this.isCollapsed = false;
        this.form.markAsPristine();

        this.resultAccionesPerfilTipoEstadoEx = new WAccionesPerfilTipoEstadoExItemResultsViewModel();
    }

    onAdd(): void {
        this.router.navigate(['/mantenimiento/permisos/accionesperfiltipoestadoEx/create']);
    }

    onEdit(item: WAccionesPerfilTipoEstadoExViewModel): void {
        this.router.navigate(['/mantenimiento/permisos/accionesperfiltipoestadoEx/edit', item.Id]);
    }

    onDelete(item: WAccionesPerfilTipoEstadoExViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.accionesPerfilTipoEstadoExService.deleteAccionesPerfilTipoEstado(item.Id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Permiso acción eliminado correctamente');
                        this.onSearchButton();
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    createModel(): FilterSearchingWAccionesPerfilTipoEstadoExViewModel {
        let model: FilterSearchingWAccionesPerfilTipoEstadoExViewModel = new FilterSearchingWAccionesPerfilTipoEstadoExViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onSelectTipoSolicitudEx(): void {
        if (this.form.value.IdTipo === EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS) {
            this.globalService.getSubTipoSolicitudExpor().subscribe(res => {
                this.listSubTipoSolicitudEx = res.filter(s => s.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS);
            });
        } else if (this.form.value.IdTipo === EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION) {
            this.globalService.getSubTipoSolicitudExpor().subscribe(res => {
                this.listSubTipoSolicitudEx = res.filter(s => s.IdTipoSolicitudEx === EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION);
            });
        } else {
            this.listSubTipoSolicitudEx = [];
        }

        this.form.patchValue({
            IdSubTipo: null,
        });
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;

        this.accionesPerfilTipoEstadoExService.export(this.createModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.resultAccionesPerfilTipoEstadoEx?.ResultList ? this.resultAccionesPerfilTipoEstadoEx?.ResultList?.length > 0 : false;
    }
}
